import classnames from 'classnames';
import React from 'react';

import { Maybe, TheaterService } from 'types/graphql-api.generated';

import { PartialShowtime } from 'common/components/ShowtimeModal/types';

import styles from './styles.module.scss';

type AmenityIconProps = { extraClassName?: string; icon: string };

type TheaterAmenitiesProps = {
  amenities: Maybe<Array<Maybe<TheaterService>>>;
  extraClassName?: string;
  showtime?: Maybe<PartialShowtime>;
};

const amenitiesIcons: Record<string, TheaterService[]> = {
  candy: [TheaterService.CandyStore],
  handicap: [TheaterService.DisabledAccess],
  restaurant: [TheaterService.TheaterRestaurant]
};

const AmenityIcon = ({ extraClassName, icon }: AmenityIconProps) => (
  <span
    className={classnames(
      extraClassName,
      styles.amenity,
      'square',
      'icon',
      `icon-${icon}`
    )}
    key={icon}
  />
);
const TheaterAmenities = ({
  amenities,
  extraClassName,
  showtime
}: TheaterAmenitiesProps) => {
  if (!showtime) {
    return null;
  }

  return (
    <>
      {amenities?.map((amenity, index) => {
        for (const icon in amenitiesIcons) {
          if (amenity && amenitiesIcons[icon].includes(amenity)) {
            return (
              <AmenityIcon
                extraClassName={extraClassName}
                key={`${index}-${icon}`}
                icon={icon}
              />
            );
          }
        }
        return null;
      })}
    </>
  );
};

export default TheaterAmenities;
